// import ImageSection from "../../components/Login/ImageSection";
import SetNewPasswordForm from "../../components/Login/SetNewPassword";
import Image from "../../assets/login/login.webp";
import Image_LQ from "../../assets/login/login_lq.webp";

const SetNewPassword = () => {
  return (
    <div className="w-full sm:w-[80%] lg:w-[500px] xl2:w-[612px] h-[400px] xl2:h-[550px] bg-white/90 p-6 rounded-[20px] lg:shadow-[4px_4px_32px_rgba(36,132,147,0.2)]">
      <SetNewPasswordForm />
    </div>
  );
};

export default SetNewPassword;
